const { SELECTORS, STAGES } = require('./variables');

let removedForms = '';

const hideForm = (selector, formToremove = null) => {
    $(selector).addClass('d-none');
    if (formToremove) {
        if (removedForms === '') {
            removedForms = $(formToremove).prop('outerHTML');
        }
        $(formToremove).remove();
    }
}

const renderRenderedTemplate = (template, container) => {
    $(container).empty().html(template);
}

const showComponent = (selector) => { $(selector).removeClass('d-none'); }

const hideComponent = (selector) => { $(selector).addClass('d-none'); }

const restoreForm = () => {
    const html = removedForms;
    if (!html) return;
    $(SELECTORS.formsContainer).append(html);
    removedForms = '';
};

const resetAllForms = () => {
    $(SELECTORS.formsContainer).find('form').each(function () {
        this.reset();
        resetAllSelects(SELECTORS.formsContainer);
    });
}

const showForm = (selector, submitUrl, form) => {
    $(selector).removeClass('d-none');
    $(selector).attr('action', submitUrl);

    // Fill already compiled inputs
    $.each(form, function (key, value) {
        // isForeigner is controlled client-side from phone prefix (+39 => false)
        if (key === 'isForeigner') {
            return;
        }
        if (value && value.htmlValue && value.valid) {
            const input = $(`${selector} input[name="${value.htmlName}"]`);
            input.val(value.htmlValue);
            if (value.hasOwnProperty('checked') && value.checked === true) {
                input.attr('checked', 'checked');
            }
        }
    });

    // Hanlde pre-fill event registration fields
    $(SELECTORS.eventRegistrationForm).find('input, textarea, select').each(function () {
        if ($(this).val().trim() !== '') {
            $(this).trigger('input');
        }
    });

    if (selector === SELECTORS.eventMinorRegistrationForm || selector === SELECTORS.eventAdultRegistrationForm) {
        $(SELECTORS.backButton).removeClass('d-none');
    } else {
        $(SELECTORS.backButton).addClass('d-none');
    }

    touchForm(selector);
    clearFormErrors(selector);
}

const registrationCompleted = (template) => {
    hideComponent(SELECTORS.docuSignContainer);
    showComponent(SELECTORS.registrationCompleted);
    $(SELECTORS.modalHeader).addClass('d-none');
    if(template){
        renderRenderedTemplate(template, SELECTORS.registrationCompletedDetails);
    }
    updateStage(STAGES.completed);
}

const registrationRefused = () => {
    hideComponent(SELECTORS.docuSignContainer);
    showComponent(SELECTORS.registrationRefused);
    updateStage(STAGES.refused);
}

const backToRegistrationForm = (data) =>{
    hideComponent(SELECTORS.docuSignContainer);
    showForm(data.isMinor ? SELECTORS.eventMinorRegistrationForm : SELECTORS.eventAdultRegistrationForm);
    hideForm(!data.isMinor ? SELECTORS.eventMinorRegistrationForm : SELECTORS.eventAdultRegistrationForm);
    updateStage(data.isMinor ? STAGES.minorRegistration : STAGES.adultRegistration);
}

const updateStage = (stage) => {
    const url = new URL(window.location.href);
    url.searchParams.set('eventStage', stage);
    const newUrl =
      window.location.pathname +
      '?' + url.searchParams.toString() +
      window.location.hash;
    
    history.pushState(null, '', newUrl);
}


const getCurrentStage = (stage) => {
    const url = new URL(window.location);
    const eventStage = url.searchParams.get('eventStage');
    return eventStage;
}

const addFormValidation = (form, fields) => {
    if(form){
        const $form = $(form);
        $form.find('input, textarea, select').each(function () {
            const $field = $(this);
            if ($field.hasClass('js-form-control-disabled')) {
                $field.removeClass('js-form-control-disabled')
                      .addClass('js-form-control');
            }
            if ($field.hasClass('js-select-validate-disabled')) {
                $field.removeClass('js-select-validate-disabled')
                      .addClass('js-select-validate');
            }
        });
    }

    if (fields) {
        const $fields = $(fields);
        $fields.find('input, textarea, select').each(function () {
            const $field = $(this);
            if ($field.hasClass('js-form-control-disabled')) {
                $field.removeClass('js-form-control-disabled')
                      .addClass('js-form-control');
            }
            if ($field.hasClass('js-select-validate-disabled')) {
                $field.removeClass('js-select-validate-disabled')
                      .addClass('js-select-validate');
            }
        });
    }
};

const removeFormValidation = (form, fields) => {
    if(form){
        const $form = $(form);
        $form.find('input, textarea, select').each(function () {
            const $field = $(this);
            if ($field.hasClass('js-form-control')) {
                $field.removeClass('js-form-control')
                      .addClass('js-form-control-disabled');
            }
            if ($field.hasClass('js-select-validate')) {
                $field.removeClass('js-select-validate')
                      .addClass('js-select-validate-disabled');
            }
        });
    }

    if (fields) {
        const $fields = $(fields);
        $fields.find('input, textarea, select').each(function () {
            const $field = $(this);
            if ($field.hasClass('js-form-control')) {
                $field.removeClass('js-form-control')
                      .addClass('js-form-control-disabled');
            }
            if ($field.hasClass('js-select-validate')) {
                $field.removeClass('js-select-validate')
                      .addClass('js-select-validate-disabled');
            }
        });
    }
};

function clearFormErrors(form) {
    $(form).find('.form-control.cc-invalid').removeClass('cc-invalid');
    $(form).find('.form-control').removeAttr('aria-invalid');
    $(form).find('.invalid-feedback').removeClass('cc-message--visible').text('');
    $(form).find('.cc-form__wrap--error').removeClass('cc-form__wrap--error');
    $(form).find('.js-icon--warning').remove();
}

function clearInviteFriendForm(){
    $(SELECTORS.inviteFriendFname).val('').removeClass('cc-disabled').prop('disabled', false);
    $(SELECTORS.inviteFriendLname).val('').removeClass('cc-disabled').prop('disabled', false);
    $(SELECTORS.inviteFriendInput).val('').removeClass('cc-disabled').prop('disabled', false);
    $(SELECTORS.inviteFriendFname).removeClass('cc-form__input--readonly').prop('readonly', false).removeAttr('aria-readonly');
    $(SELECTORS.inviteFriendLname).removeClass('cc-form__input--readonly').prop('readonly', false).removeAttr('aria-readonly');
}

function touchForm(form) {
    $(form).find('input, textarea, select').each(function () {
        $(this).trigger('input');
    });
}

function touchFilledForm(form) {
    $(form).find('input, textarea, select').each(function () {
        if($(this).val() !== ''){
            $(this).trigger('input');
        }
    });
}

function resetAllSelects(selector) {
    const container = document.querySelector(selector);
    if (!container) return false;

    const selects = container.querySelectorAll('select');

    selects.forEach(sel => {
        const $sel = $(sel);

        // Phone prefix must restore the default (+39), not the first option
        if ($sel.hasClass('js-select-prefix')) {
            $sel.val('+39');
            if (typeof $sel.selectpicker === 'function') {
                $sel.selectpicker('val', '+39');
                $sel.selectpicker('refresh');
            }
            $sel.closest('.cc-form__column-prefix').find('.js-is-foreigner').val('false');
            $sel.trigger('change');
            return;
        }

        sel.selectedIndex = 0;
        sel.dispatchEvent(new Event('change', { bubbles: false }));
        if ($sel.hasClass('selectpicker') && typeof $sel.selectpicker === 'function') {
            $sel.selectpicker('refresh');
        }
    });

    return true;
}

function clearParams() {
    try {
        const url = new URL(window.location.href);
        url.searchParams.delete('eventStage');
        
        const newUrl =
          window.location.pathname +
          (url.searchParams.toString() ? '?' + url.searchParams.toString() : '') +
          window.location.hash;
        
        window.history.replaceState({}, '', newUrl);
    } catch (error) {
        console.log('Log err remove params => ', error);
    }
};

const getInvitedUrl = ($form) => {
    let invitedUrl = false;
    var invitedEmail = $form.find('.js-invited-friend-email').val();
    var invitedByEmail = $form.find('input[name="dwfrm_fullEvent_fullEvent_email"]').val();
    if($form.find('.js-invite-friend-checkbox').prop('checked') && (invitedEmail || invitedEmail !== '')){
        let eventId = $(SELECTORS.dataset).data('event-id');
        let eventParentId = $(SELECTORS.dataset).data('event-parent-id');
        let canonicalUrl = $('link[rel="canonical"]').attr('href');
        invitedUrl = new URL(canonicalUrl);
        invitedUrl.searchParams.set('master', eventParentId);
        invitedUrl.searchParams.set('child', eventId);
        invitedUrl.searchParams.set('email', invitedEmail);
        invitedUrl.searchParams.set('invitedBy', invitedByEmail);
        invitedUrl = invitedUrl.toString();
    }
    return invitedUrl;
}

const goBack = async (removeParams) => {
    const $formsContainer = $(SELECTORS.formsContainer);
    if ($formsContainer.length) {
        const url = $formsContainer.data('clear-form');
        if (url) {
            
            // Reset form.xml from BE
            const response = await fetch(url);
            if (!response.ok) {
              console.error('Impossible to clear form');
              return;
            }
            const data = await response.json();

            // Reset form from FE
            if(data.success){
                $(SELECTORS.eventDetails).empty();
                restoreForm();
                resetAllForms();
                hideForm(SELECTORS.eventMinorRegistrationForm);
                hideForm(SELECTORS.eventAdultRegistrationForm);
                hideComponent(SELECTORS.registrationCompleted);
                hideComponent(SELECTORS.registrationRefused);
                clearFormErrors(SELECTORS.checkUserForm);
                showForm(SELECTORS.checkUserForm);
                $(SELECTORS.docuSignContainer).empty();
                updateStage(STAGES.checkUser);
                removeFormValidation(SELECTORS.eventAdultRegistrationForm);
                removeFormValidation(SELECTORS.eventMinorRegistrationForm);
                touchForm(SELECTORS.checkUserForm);
            }

            if(removeParams){
                clearParams();
            }
        }
    }
}

const toggleInviteFriendFields = () => {
    const isChecked = $(SELECTORS.inviteFriendCheckbox).is(':checked');
    if (isChecked) {
        $(SELECTORS.inviteFriendFields).removeClass('d-none');
        addFormValidation(null, SELECTORS.inviteFriendFields);
        addRequired();
    } else {
        $(SELECTORS.inviteFriendFields).addClass('d-none');
        $('body').trigger('formValidation:clearInviteFriendsFields', 'dwfrm_fullEvent');
        removeFormValidation(null, SELECTORS.inviteFriendFields);
        removeRequired();
        clearInviteFriendForm();
    }
};

const addRequired = () => {
    const $field = $(SELECTORS.inviteFriendFields);

    $field.find('.js-form-wrap')
        .addClass('required cc-required');

    $field.find('input')
        .attr('required', true);
};

const removeRequired = () => {
    const $field = $(SELECTORS.inviteFriendFields);

    $field.find('.js-form-wrap')
        .removeClass('required cc-required');

    $field.find('input')
        .removeAttr('required');
};

const preFillSelects = (currentForm) => {
    let loggedUser = $(SELECTORS.dataset);
    let gender = loggedUser.data('gender');
    let stateCode = loggedUser.data('statecode');
    if(gender){
        $(currentForm).find('.js-gender-select').val(gender).change();
    }
    if(stateCode){
        $(currentForm).find('select[name="dwfrm_fullEvent_fullEvent_states_stateCode"]').val(stateCode).change();
    }
}

const openInviteFriendEvent = () =>{
    const params = new URLSearchParams(window.location.search);
    const master = params.get('master');
    const child  = params.get('child');
    const email  = params.get('email');
    let loggedUser = $(SELECTORS.dataset);

    if(master && child && email && loggedUser.data('email').toLowerCase() === email.toLowerCase() && loggedUser.data('authenticated')){
        const $button = $(`${SELECTORS.eventSelected}[data-event-id="${child}"]`);
        $button.trigger('click');
    }
}

const removeInvitefriendParams = () => {
    const params = new URLSearchParams(window.location.search);
    params.delete('master');
    params.delete('child');
    params.delete('email');
    params.delete('invitedBy');
    const newUrl =
        window.location.pathname +
        (params.toString() ? '?' + params.toString() : '') +
        window.location.hash;
    window.history.replaceState({}, document.title, newUrl);
}

function validateEmail(email, action, callback) {
    const emailReg = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    const validEmail = emailReg.test(String(email).toLowerCase());

    if (validEmail) {
        $.spinner().start();
        $.ajax({
            url: action,
            method: 'POST',
            data: { email: email },
            success: function(response) {
                callback(response);
                $.spinner().stop();
            },
            error: function(error) {
                $.spinner().stop();
                console.error(error);
            }
        });
    }
}

module.exports = {
    hideForm: hideForm,
    showForm: showForm,
    hideComponent: hideComponent,
    showComponent: showComponent,
    restoreForm: restoreForm,
    resetAllForms: resetAllForms,
    goBack: goBack,
    updateStage: updateStage,
    registrationCompleted: registrationCompleted,
    registrationRefused: registrationRefused,
    renderRenderedTemplate: renderRenderedTemplate,
    backToRegistrationForm: backToRegistrationForm,
    getCurrentStage: getCurrentStage,
    addFormValidation: addFormValidation,
    removeFormValidation: removeFormValidation,
    toggleInviteFriendFields: toggleInviteFriendFields,
    touchForm: touchForm,
    touchFilledForm: touchFilledForm,
    clearFormErrors: clearFormErrors,
    addRequired: addRequired,
    removeRequired: removeRequired,
    clearParams: clearParams,
    preFillSelects: preFillSelects,
    getInvitedUrl: getInvitedUrl,
    openInviteFriendEvent: openInviteFriendEvent,
    removeInvitefriendParams: removeInvitefriendParams,
    validateEmail: validateEmail
};
